import { EntityFilterRestriction } from "../EntityList/types";

/** Ключ корневой ноды дерева фильтра — тот же формат, что в `attr2TreeData` для значения атрибута. */
export const makeFilterRestrictionNodeKey = (
  restriction: EntityFilterRestriction,
): string =>
  `${String(restriction.filterAttrId)}-${restriction.filterValueStr}`;
